// extracted by css-extract-rspack-plugin
export default {"errorBanner":"ErrorBanner-module__errorBanner__dTzBul7"};